<mat-icon title="{{ 'general.favoriteRemove' | translate }}" *ngIf="IsFavorite">star</mat-icon>
<mat-icon title="{{ 'general.favoriteAdd' | translate }}" *ngIf="!IsFavorite">star_border</mat-icon>
